export const NATIONALITY_CRS_GROUP_KEY = "nationalities";
